/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ConnectInfo} from './ConnectInfo';
import {ConnectInfoFromJSON, ConnectInfoFromJSONTyped, ConnectInfoToJSON} from './ConnectInfo';

/**
 *
 * @export
 * @interface BodyTechProcessRemoveConnection
 */
export interface BodyTechProcessRemoveConnection {
  /**
   *
   * @type {ConnectInfo}
   * @memberof BodyTechProcessRemoveConnection
   */
  targetInfo: ConnectInfo;
  /**
   *
   * @type {ConnectInfo}
   * @memberof BodyTechProcessRemoveConnection
   */
  sourceInfo: ConnectInfo;
}

/**
 * Check if a given object implements the BodyTechProcessRemoveConnection interface.
 */
export function instanceOfBodyTechProcessRemoveConnection(
  value: object
): value is BodyTechProcessRemoveConnection {
  if (!('targetInfo' in value) || value['targetInfo'] === undefined) return false;
  if (!('sourceInfo' in value) || value['sourceInfo'] === undefined) return false;
  return true;
}

export function BodyTechProcessRemoveConnectionFromJSON(
  json: any
): BodyTechProcessRemoveConnection {
  return BodyTechProcessRemoveConnectionFromJSONTyped(json, false);
}

export function BodyTechProcessRemoveConnectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BodyTechProcessRemoveConnection {
  if (json == null) {
    return json;
  }
  return {
    targetInfo: ConnectInfoFromJSON(json['target_info']),
    sourceInfo: ConnectInfoFromJSON(json['source_info'])
  };
}

export function BodyTechProcessRemoveConnectionToJSON(
  value?: BodyTechProcessRemoveConnection | null
): any {
  if (value == null) {
    return value;
  }
  return {
    target_info: ConnectInfoToJSON(value['targetInfo']),
    source_info: ConnectInfoToJSON(value['sourceInfo'])
  };
}
